import { Link } from "wouter";
import { Container } from "@/components/public/institutional-ui";
import { ArrowRight } from "lucide-react";
import { FadeIn } from "@/components/ui/scroll-animations";

/** Investor login — off nav/footer; shown where LPs expect portal access */
export function InvestorPortalBand() {
  return (
    <section className="border-y border-border bg-foreground text-background">
      <Container className="py-10 md:py-12">
        <FadeIn>
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
            <div className="max-w-xl">
              <p className="text-[11px] font-medium uppercase tracking-[0.22em] text-background/50 mb-3">
                Investor portal
              </p>
              <h2 className="text-xl md:text-2xl font-medium tracking-tight mb-3">
                For existing investors &amp; Velocity Fund partners
              </h2>
              <p className="text-sm text-background/70 leading-relaxed">
                Secure access to portfolio updates, statements, and fund communications.
              </p>
            </div>
            <Link href="/login" aria-label="Investor portal">
              <span
                className="inline-flex items-center gap-2 border border-background/40 px-6 h-12 text-sm hover:bg-background hover:text-foreground transition-colors cursor-pointer shrink-0"
                data-cursor-label="Investor portal"
              >
                Investor portal
                <ArrowRight className="h-4 w-4" />
              </span>
            </Link>
          </div>
        </FadeIn>
      </Container>
    </section>
  );
}
